
import React from 'react';
import { Link } from 'react-router-dom';
import FooterLinkGroup from './FooterLinkGroup';
import { Search, Star, Sparkles, TrendingUp } from 'lucide-react';

const ProductLinks: React.FC = () => {
  const links = [
    {
      to: "/browse",
      label: "Browse All Agents",
      icon: <Search className="h-3.5 w-3.5" />
    },
    {
      to: "/browse?tab=featured",
      label: "Featured Agents",
      icon: <Star className="h-3.5 w-3.5" />
    },
    {
      to: "/browse?tab=new",
      label: "New Releases",
      icon: <Sparkles className="h-3.5 w-3.5" />
    },
    {
      to: "/browse?tab=popular",
      label: "Popular Agents",
      icon: <TrendingUp className="h-3.5 w-3.5" />
    }
  ];

  return (
    <FooterLinkGroup title="Explore" links={links} />
  );
};

export default ProductLinks;
